import { MapPin, MessageCircle, Navigation, Clock3, Route } from "lucide-react";
import { WA_LINK } from "../lib/constants";
import { Button } from "./ui/button";

export const SERVICE_AREAS = [
  {
    id: "sangam-vihar",
    name: "Sangam Vihar",
    headline: "Best Computer Training Centre in Sangam Vihar",
    travel: "Our centre is located here — D613, Block D, Ratiya Marg, Gali No. 3",
    desc: "TASSEI is the home-ground computer institute of Sangam Vihar. Students from every block — A to L — join our DCA, Advanced Excel, Tally and Digital Literacy programs with lifetime free practice and placement assistance.",
    landmarks: ["Opposite Lord Krishna Public School", "Ratiya Marg", "Hamdard Nagar Bus Stand"],
  },
  {
    id: "tigri",
    name: "Tigri",
    headline: "Computer Classes near Tigri & Tigri Extension",
    travel: "5–10 min by e-rickshaw or on foot from Tigri Extension",
    desc: "Looking for a computer training centre in Tigri? TASSEI is just a short ride away. Students from Tigri, Tigri Extension and Khanpur choose us for small 8-student batches, job-oriented courses and flexible 8 AM – 8 PM timings.",
    landmarks: ["Tigri Extension", "Khanpur", "Sainik Farm Road"],
  },
  {
    id: "deoli",
    name: "Deoli",
    headline: "Computer Institute for Deoli & Deoli Extension",
    travel: "10–15 min by e-rickshaw via Deoli Road / Ratiya Marg",
    desc: "Searching for the best computer institute in Deoli? Students from Deoli Village, Deoli Extension and Dakshinpuri come to TASSEI for 100% practical learning, certified courses and monthly fee options with no hidden charges.",
    landmarks: ["Deoli Village", "Deoli Extension", "Dakshinpuri"],
  },
  {
    id: "tughlakabad",
    name: "Tughlakabad",
    headline: "Computer Training near Tughlakabad & Tughlakabad Extension",
    travel: "10–15 min by auto from Tughlakabad Extension; Badarpur Border & Govind Puri metro nearby",
    desc: "Want a job-oriented computer course near Tughlakabad? TASSEI in Sangam Vihar is the nearest career-focused centre for students from Tughlakabad Extension, Tughlakabad Village and Govind Puri — with placement assistance until you get a job.",
    landmarks: ["Tughlakabad Extension", "Govind Puri Metro", "Badarpur Border Metro"],
  },
];

export const AreaLandingSection = () => (
  <section className="py-20 md:py-24 bg-[#F8FAF9] relative overflow-hidden" data-testid="service-areas-section" aria-labelledby="service-areas-heading">
    <div className="absolute inset-0 tassei-dot-bg opacity-40 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 md:px-10">
      <div className="max-w-3xl">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0A192F] text-[#7CF0BD] text-xs font-bold uppercase tracking-[0.22em]">
          <Navigation className="w-3.5 h-3.5" /> Areas we serve in South Delhi
        </div>
        <h2 id="service-areas-heading" className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0A192F] leading-[1.05]">
          Best Computer Training Centre in <span className="text-[#00B37E]">Sangam Vihar, Tigri, Deoli &amp; Tughlakabad</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-[#475569] leading-relaxed">
          One centre, four neighbourhoods. TASSEI.in is the most trusted <strong>computer training centre near Sangam Vihar, Tigri, Deoli and Tughlakabad</strong> — all within a 15-minute e-rickshaw ride. Job-oriented computer courses, Advanced Excel, Tally, Digital Literacy for Women and Open Board 10th/12th support, with lifetime free practice.
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        {SERVICE_AREAS.map((a) => (
          <article key={a.id} id={`area-${a.id}`} data-testid={`area-card-${a.id}`} className="group bg-white rounded-3xl border border-slate-200 p-7 hover:border-[#00B37E] hover:shadow-xl hover:shadow-[#00B37E]/10 hover:-translate-y-1 transition-all duration-300 scroll-mt-28">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-[#0A192F] flex items-center justify-center group-hover:bg-[#00B37E] transition-colors"><MapPin className="w-5 h-5 text-[#7CF0BD] group-hover:text-white" /></div>
              <div>
                <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#00B37E]">{a.name}</div>
                <h3 className="font-heading text-lg font-bold text-[#0A192F] leading-snug">{a.headline}</h3>
              </div>
            </div>
            <p className="mt-4 text-sm sm:text-base text-[#475569] leading-relaxed">{a.desc}</p>
            <div className="mt-4 flex items-start gap-2 text-sm text-[#0A192F]"><Clock3 className="w-4 h-4 text-[#00B37E] mt-0.5 flex-shrink-0" /><span>{a.travel}</span></div>
            <div className="mt-3 flex flex-wrap gap-2">
              {a.landmarks.map((l) => (
                <span key={l} className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-[#F8FAF9] border border-slate-200 text-[#475569]"><Route className="w-3 h-3 text-[#00B37E]" /> {l}</span>
              ))}
            </div>
            <a href={WA_LINK(`Hi TASSEI, I am from ${a.name} and want to know about your computer courses. Please share details.`)} target="_blank" rel="noopener noreferrer" data-testid={`area-whatsapp-${a.id}`} className="inline-block mt-6">
              <Button className="bg-[#00B37E] hover:bg-[#009166] text-white font-semibold rounded-full h-11 px-6"><MessageCircle className="w-4 h-4 mr-2" /> Enquire from {a.name}</Button>
            </a>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default AreaLandingSection;
